module.exports = __webpack_public_path__ + "img/建模看板.94cb024f.svg";